export const livesearchInit = () => {
    let $live_filter = $('.live-filter');
    $.each($live_filter, function (index, $filter) {
        var $elem = $(this).attr('data-filter');
        /* Search Filter */
        $(this).keyup(function () {
            var filter_txt = $(this).val();
            // Loop through the comment list
            $($elem + ' > div').each(function () {
                // If the list item does not contain the text phrase fade it out
                if ($(this).text().search(new RegExp(filter_txt, 'i')) < 0) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
            });
        });
    });
};
